/* tslint:disable */
/* eslint-disable */
/**
 * Kiwi Framework
 * Kiwi API description
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MaterialEditResponse
 */
export interface MaterialEditResponse {
    /**
     * 
     * @type {string}
     * @memberof MaterialEditResponse
     */
    materialId: string;
}

/**
 * Check if a given object implements the MaterialEditResponse interface.
 */
export function instanceOfMaterialEditResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "materialId" in value;

    return isInstance;
}

export function MaterialEditResponseFromJSON(json: any): MaterialEditResponse {
    return MaterialEditResponseFromJSONTyped(json, false);
}

export function MaterialEditResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MaterialEditResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'materialId': json['materialId'],
    };
}

export function MaterialEditResponseToJSON(value?: MaterialEditResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'materialId': value.materialId,
    };
}

